import ProjectFavorite from './ProjectFavorite';

export default ProjectFavorite;
